const types = {
    PROGRESS_PROGRESS_BAR_VALUE: 'PROGRESS_PROGRESS_BAR_VALUE',
};

const progressActions = {
    types,

    setFooterProgressBarValue(progressBarValue) {
        return { type: this.types.PROGRESS_PROGRESS_BAR_VALUE, progressBarValue };
    },
};

export default progressActions;
